export const thumbnailGeoJsonData = {
  "type": "FeatureCollection",
  "features": [
    {
      "type": "Feature",
      "properties": {},
      "geometry": {
        "coordinates": [
          [
            [
              -89.6384803,
              39.6520975
            ],
            [
              -89.6386854,
              39.6630918
            ],
            [
              -89.6386791,
              39.6639281
            ],
            [
              -89.6384607,
              39.6655463
            ],
            [
              -89.6382226,
              39.6664774
            ],
            [
              -89.6371708,
              39.6700476
            ],
            [
              -89.6295479,
              39.6701965
            ],
            [
              -89.6294665,
              39.6664593
            ],
            [
              -89.6293806,
              39.6593683
            ],
            [
              -89.6293074,
              39.6557599
            ],
            [
              -89.6292181,
              39.6484343
            ],
            [
              -89.6371957,
              39.6482137
            ],
            [
              -89.6372383,
              39.6490778
            ],
            [
              -89.6384545,
              39.6490502
            ],
            [
              -89.6384803,
              39.6520975
            ]
          ],
          [
            [
              -89.6335984,
              39.6556789
            ],
            [
              -89.633591,
              39.6555569
            ],
            [
              -89.6297476,
              39.655622
            ],
            [
              -89.629752,
              39.65574
            ],
            [
              -89.6335984,
              39.6556789
            ]
          ],
          [
            [
              -89.6339289,
              39.6556769
            ],
            [
              -89.6339159,
              39.6537542
            ],
            [
              -89.6337884,
              39.6537893
            ],
            [
              -89.633801,
              39.6556777
            ],
            [
              -89.6339289,
              39.6556769
            ]
          ]
        ],
        "bounds": [
          [
            39.6482137,
            -89.6386854
          ],
          [
            39.6701965,
            -89.6292181
          ]
        ],
        "type": "Polygon"
      }
    },
    {
      "type": "Feature",
      "properties": {},
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              -89.637022,
              39.65877
            ],
            [
              -89.637022,
              39.662206
            ],
            [
              -89.635048,
              39.662206
            ],
            [
              -89.635048,
              39.65877
            ],
            [
              -89.637022,
              39.65877
            ]
          ]
        ]
      }
    }
  ]
};

export const regionGeoJson = {
  "type": "Feature",
  "properties": {},
  "geometry": {
      "type": "Polygon",
      "coordinates": [
          [
              [
                  -89.5966199040413,
                  38.105839703119706
              ],
              [
                  -89.59663787948139,
                  38.10583810943024
              ],
              [
                  -89.5966549535556,
                  38.10583340827627
              ],
              [
                  -89.59667027009675,
                  38.10582583539387
              ],
              [
                  -89.59668306106849,
                  38.105815770519804
              ],
              [
                  -89.5966926850781,
                  38.105803718349776
              ],
              [
                  -89.59669865953857,
                  38.10579028323076
              ],
              [
                  -89.59670068486729,
                  38.10577613885629
              ],
              [
                  -89.59669865950806,
                  38.10576199448455
              ],
              [
                  -89.59669268502316,
                  38.10574855937321
              ],
              [
                  -89.59668306099998,
                  38.105736507214274
              ],
              [
                  -89.59667027002823,
                  38.10572644235252
              ],
              [
                  -89.59665495350065,
                  38.1057188694812
              ],
              [
                  -89.5966378794509,
                  38.10571416833491
              ],
              [
                  -89.5966199040413,
                  38.10571257464818
              ],
              [
                  -89.59660192863173,
                  38.10571416833491
              ],
              [
                  -89.59658485458198,
                  38.1057188694812
              ],
              [
                  -89.5965695380544,
                  38.10572644235252
              ],
              [
                  -89.59655674708266,
                  38.105736507214274
              ],
              [
                  -89.59654712305945,
                  38.10574855937321
              ],
              [
                  -89.59654114857454,
                  38.10576199448455
              ],
              [
                  -89.59653912321535,
                  38.10577613885629
              ],
              [
                  -89.59654114854406,
                  38.10579028323076
              ],
              [
                  -89.59654712300451,
                  38.105803718349776
              ],
              [
                  -89.59655674701412,
                  38.105815770519804
              ],
              [
                  -89.59656953798587,
                  38.10582583539387
              ],
              [
                  -89.59658485452701,
                  38.10583340827627
              ],
              [
                  -89.59660192860122,
                  38.10583810943024
              ],
              [
                  -89.5966199040413,
                  38.105839703119706
              ]
          ]
      ]
  }
};